<template>
	<div>
		<div class="common_box_tit">
			<div>视频文件</div>
			<div class="bom_line"></div>
		</div>
		<div class="hyfc" v-if="spList.length>0">
			<div class="recommendPage">
				<video-player
				        class="video-player"
				        ref="videoPlayer"
				        :options="playerOptions"
				      >
				</video-player>
				<div class="name">{{spList[0].name}}</div>
			</div>
			<div class="more_box">
				<div class="flex_tit">
					<div class="tit">更多推荐</div>
					<div @click="goVideo" class="common_more" style="float: right;margin-top: 10px;">
						<span>更多</span>
						<span class="iconfont icon-gengduo"></span>
					</div>
				</div>
				<!-- <img src="../../assets/images/4.png"/> -->
				<div class="list_box">
					<div class="item" v-for="(it,i) in spList" :key="i">
						<video-player ref="videoPlayer" :options="playerOptions">
						</video-player>
						<div class="name single">{{it.name}}</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getResourcese
	} from '@/api/home/guild'
	import {
		videoPlayer
	} from "vue-video-player";
	import 'video.js/dist/video-js.css'
	export default {
		components: {
			videoPlayer,
		},
		data() {
			return {
				spList: [],
				mediaUrl: null, // 播放视频的路径
				// 视频控制设置
				playerOptions: {
					playbackRates: [1.0], // 可选的播放速度
					autoplay: true, // 如果为true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: "zh-CN",
					aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4", // 类型
						src: "", // url地址
					}, ],
					poster: "", // 封面地址
					notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: true, // 是否显示剩余时间功能
						fullscreenToggle: true, // 是否显示全屏按钮
					},
				}
			}

		},
		mounted() {
			this.getResourceseSp();
		},
		methods: {
			getResourceseSp() {
				getResourcese({
					type: 5,
					pageNo: 1,
					pageSize: 4
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.spList = res.result;
						this.playerOptions.sources[0].src = res.result[0].resource;
					}
				})
			},
			goVideo(){
				this.$router.push({
					name:'video',
					query:{
						name:encodeURIComponent('视频文件')
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.hyfc {
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 30px;
	
		>div {
			width: 48%;
		}
	
		>div:first-child {
			box-shadow: 0px 6px 40px 0px rgba(31, 44, 69, 0.1);
		}
		.name{
			padding: 20px;
		}
	
		.more_box {
			img {
				width: 100%;
				height: 180px;
			}
			
			.flex_tit{
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 0px;
				.tit {
					color: #3E41F0;
					font-family: Source Han Sans CN;
					font-size: 20px;
					white-space: nowrap;
				}
			}
	
	
			.list_box {
				display: flex;
				flex-wrap: wrap;
				.item{
					box-shadow: 0px 6px 40px 0px rgba(31, 44, 69, 0.1);
					margin: 10px;
					.name{
						font-size: 13px;
						padding: 10px;
					}
				}
			}
		}
	}
</style>
